::ng-deep app-elite-form-group-container{display:flex;width:100%}::ng-deep app-elite-form-group-container app-dialog-filed-elite-form-group-editor{width:100%}
/*# sourceMappingURL=elite-form-group-container.component-EJ4N63KJ.css.map */
